export const GRID_DEFAULT_LOCALE_TEXT = {
  // Root
  noRowsLabel: 'Nema redova',
  noResultsOverlayLabel: 'Rezultati nisu pronađeni.',

  // Density selector toolbar button text
  toolbarDensity: 'Zbijenost',
  toolbarDensityLabel: 'Zbijenost',
  toolbarDensityCompact: 'Zbijeno',
  toolbarDensityStandard: 'Standardno',
  toolbarDensityComfortable: 'Komforno',

  // Columns selector toolbar button text
  toolbarColumns: 'Kolone',
  toolbarColumnsLabel: 'Odaberi kolone',

  // Filters toolbar button text
  toolbarFilters: 'Filteri',
  toolbarFiltersLabel: 'Prikaži filtere',
  toolbarFiltersTooltipHide: 'Sakriji filtere',
  toolbarFiltersTooltipShow: 'Prikaži filtere',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktivnih filtera` : `${count} aktivan filter`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Pretraži...',
  toolbarQuickFilterLabel: 'Pretraži',
  toolbarQuickFilterDeleteIconLabel: 'Očisti',

  // Export selector toolbar button text
  toolbarExport: 'Preuzimanje',
  toolbarExportLabel: 'Preuzimanje',
  toolbarExportCSV: 'Preuzimanje kao CSV',
  toolbarExportPrint: 'Štampa',
  toolbarExportExcel: 'Preuzimanje as Excel',

  // Columns panel text
  columnsPanelTextFieldLabel: 'Pronađi kolonu',
  columnsPanelTextFieldPlaceholder: 'Naziv kolone',
  columnsPanelDragIconLabel: 'Promeni redosled kolone',
  columnsPanelShowAllButton: 'Prikaži sve',
  columnsPanelHideAllButton: 'Sakriji sve',

  // Filter panel text
  filterPanelAddFilter: 'Dodaj filter',
  filterPanelRemoveAll: 'Ukloni sve',
  filterPanelDeleteIconLabel: 'Obriši',
  filterPanelLogicOperator: 'Logički operator',
  filterPanelOperator: 'Operator',
  filterPanelOperatorAnd: 'I',
  filterPanelOperatorOr: 'Ili',
  filterPanelColumns: 'Kolone',
  filterPanelInputLabel: 'Vrednost',
  filterPanelInputPlaceholder: 'Vrednost filtera',

  // Filter operators text
  filterOperatorContains: 'sadrži',
  filterOperatorEquals: 'je jednako',
  filterOperatorStartsWith: 'počinje sa',
  filterOperatorEndsWith: 'završava se sa',
  filterOperatorIs: 'je',
  filterOperatorNot: 'nije',
  filterOperatorAfter: 'posle',
  filterOperatorOnOrAfter: 'na ili posle',
  filterOperatorBefore: 'pre',
  filterOperatorOnOrBefore: 'na ili pre',
  filterOperatorIsEmpty: 'prazno',
  filterOperatorIsNotEmpty: 'nije prazno',
  filterOperatorIsAnyOf: 'bilo koji od',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

  // Header filter operators text
  headerFilterOperatorContains: 'Sadrži',
  headerFilterOperatorEquals: 'Je jednako',
  headerFilterOperatorStartsWith: 'Počinje sa',
  headerFilterOperatorEndsWith: 'Završava se sa',
  headerFilterOperatorIs: 'Je',
  headerFilterOperatorNot: 'Nije',
  headerFilterOperatorAfter: 'Posle',
  headerFilterOperatorOnOrAfter: 'Na ili posle',
  headerFilterOperatorBefore: 'Pre',
  headerFilterOperatorOnOrBefore: 'Na ili pre',
  headerFilterOperatorIsEmpty: 'Prazno',
  headerFilterOperatorIsNotEmpty: 'Nije prazno',
  headerFilterOperatorIsAnyOf: 'Bilo koji od',
  'headerFilterOperator=': 'Jednako',
  'headerFilterOperator!=': 'Nije jednako',
  'headerFilterOperator>': 'Veće od',
  'headerFilterOperator>=': 'Veće ili jednako od',
  'headerFilterOperator<': 'Manje od',
  'headerFilterOperator<=': 'Manje ili jednako od',

  // Filter values text
  filterValueAny: 'sve',
  filterValueTrue: 'da',
  filterValueFalse: 'ne',

  // Column menu text
  columnMenuLabel: 'Meni',
  columnMenuShowColumns: 'Prikaži kolone',
  columnMenuManageColumns: 'Upravljaj kolonama',
  columnMenuFilter: 'Filter',
  columnMenuHideColumn: 'Sakriji kolonu',
  columnMenuUnsort: 'Poništi redosled',
  columnMenuSortAsc: 'Poređaj uzlazno',
  columnMenuSortDesc: 'Poređaj silazno',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktivnih filtera` : `${count} aktivan filter`,
  columnHeaderFiltersLabel: 'Prikaži filtere',
  columnHeaderSortIconLabel: 'Poređaj',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} odabranih redova`
      : `${count.toLocaleString()} odabran red`,

  // Total row amount footer text
  footerTotalRows: 'Ukupno Redova:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} od ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Selektovanje',
  checkboxSelectionSelectAllRows: 'Selektuj sve redove',
  checkboxSelectionUnselectAllRows: 'Odselektuj sve redove',
  checkboxSelectionSelectRow: 'Selektuj red',
  checkboxSelectionUnselectRow: 'Odselektuj red',

  // Boolean cell text
  booleanCellTrueLabel: 'da',
  booleanCellFalseLabel: 'ne',

  // Actions cell more text
  actionsCellMore: 'više',

  // Column pinning text
  pinToLeft: 'Zakači levo',
  pinToRight: 'Zakači desno',
  unpin: 'Otkači',

  // Tree Data
  treeDataGroupingHeaderName: 'Grupa',
  treeDataExpand: 'Proširi',
  treeDataCollapse: 'Skupi',

  // Grouping columns
  groupingColumnHeaderName: 'Grupa',
  groupColumn: (name) => `Grupiši po ${name}`,
  unGroupColumn: (name) => `Ukloni grupisanje po ${name}`,

  // Master/detail
  detailPanelToggle: 'Prebacivanje panela sa detaljima',
  expandDetailPanel: 'Proširi',
  collapseDetailPanel: 'Skupi',

  // Used core components translation keys
  MuiTablePagination: {},

  // Row reordering text
  rowReorderingHeaderName: 'Redosled redova',

  // Aggregation
  aggregationMenuItemHeader: 'Agregacija',
  aggregationFunctionLabelSum: 'sum',
  aggregationFunctionLabelAvg: 'avg',
  aggregationFunctionLabelMin: 'min',
  aggregationFunctionLabelMax: 'max',
  aggregationFunctionLabelSize: 'size',
};
